var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ca4539;}.b{opacity:0;}.c{fill:#fff;}.d{fill:#707070;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-458 -5488)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4705.6,389.613l-14.7-25.08a1.718,1.718,0,0,0-2.953,0l-14.7,25.08a1.678,1.678,0,0,0,1.475,2.518h29.4A1.678,1.678,0,0,0,4705.6,389.613Zm-16.174-1.274a1.607,1.607,0,1,1,1.693-1.6A1.6,1.6,0,0,1,4689.431,388.339Zm1.736-11.418-.591,7.148h-2.29l-.573-7.148-.022-1.074a1.68,1.68,0,0,1,.5-1.245,1.81,1.81,0,0,1,2.5,0,1.7,1.7,0,0,1,.5,1.245Z",
    transform: "translate(-4213.93 5127.588)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 35,
    height: 35,
    transform: "translate(493 5523) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1,1V34H34V1H1M0,0H35V35H0Z",
    transform: "translate(493 5523) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon_alert.7616f204737533f7dce27462290f5e21.svg";
export { ForwardRef as ReactComponent };